/**
 * General settings for the memory bank.
 */

export const ViewBox = {
  HEIGHT: 345,
  WIDTH: 860,
};

export const Circle = {
  // HACK: to work around an issue with tipped/jquery, we specify an equivalent
  // CSS rule in stylesheets/partials/memory-bank/_base.sass, ensure that's
  // also updated when changing this
  RADIUS: 10,
  RADIUS_HOVER: 11,
  RADIUS_BULGE: 12,
};

export const PADLOCK_IMAGE = '/_assets/memory_bank/padlock.svg';

// Node starting or exiting position.
export const HiddenCoords = {
  X: Circle.RADIUS * 10 * -1,
  Y: ViewBox.HEIGHT,
};

export const Text = {
  OFFSET: 4,
};

export const Animation = {
  SLOWEST: 1200,
  SLOW:    500,
  MEDIUM:  300,
  FAST:    200,
};

/**
 * Default tooltip options for Tipped.
 */
export const Tooltip = {
  offset: {
    y: -1,
  },
  fadeIn: 0,
};
